import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import Tooltip from 'components/tooltip/Tooltip.component';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './TimeOffCategoriesHeader.module.scss';

const TimeOffCategoriesHeader = ({ calendarMode }) => (
  <div data-bem="TimeOffCategoriesHeader" className={cn(CN.row, CN[calendarMode])}>
    <span className={CN.title}>Category name</span>
    <span className={CN.title}>Colour in calendar</span>
    <span className={CN.title}>
      <Tooltip title="Inc. in working hours">
        If ticked, this type of time-off will be considered as working hours in the “hours worked” calculation, as
        opposed to time off work.
      </Tooltip>
    </span>
    <span className={CN.title}>
      <Tooltip title="Default Allowance">
        The default number of days automatically applied to each staff member for the 12 month period. This can be
        customised per person in the section below.
      </Tooltip>
    </span>
  </div>
);

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(mapStateToProps)(TimeOffCategoriesHeader);
